import { useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import AppButton from "../Common/Button/Button";
import { useDesignTokens } from "../../theme/useDesignTokens";
import { inAppPrimaryActionSx } from "../../constants/inAppNotificationConstant";

const CsvUploadField = ({
  id = "csv-upload",
  label = "Upload CSV",
  hint,
  accept = ".csv",
  onFileSelect,
  disabled = false,
}) => {
  const { colors } = useDesignTokens();
  const inputRef = useRef(null);
  const [fileName, setFileName] = useState("");

  const handleChange = (e) => {
    const file = e.target.files?.[0] || null;
    setFileName(file?.name || "");
    onFileSelect(file);
  };

  const handleBrowse = () => {
    inputRef.current?.click();
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "stretch", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1, sm: 1.5 },
          p: { xs: 1.25, sm: 1.5 },
          borderRadius: 1.5,
          border: `1px dashed ${colors?.ghost?.main || "rgba(0,0,0,0.23)"}`,
          bgcolor: "background.paper",
          transition: "border-color 0.2s, background-color 0.2s",
          "&:hover": disabled
            ? {}
            : {
                borderColor: colors?.primary?.main || "primary.main",
                bgcolor: "action.hover",
              },
        }}
      >
        <UploadFileOutlinedIcon
          color="action"
          sx={{ fontSize: { xs: 24, sm: 28 }, flexShrink: 0, alignSelf: { xs: "flex-start", sm: "center" } }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {label}
          </Typography>
          {hint && (
            <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
              {hint}
            </Typography>
          )}
          {fileName && (
            <Typography
              variant="caption"
              color="primary"
              sx={{ display: "block", mt: 0.25, wordBreak: "break-all" }}
            >
              {fileName}
            </Typography>
          )}
        </Box>
        <AppButton
          variant="primary"
          size="medium"
          onClick={handleBrowse}
          disabled={disabled}
          sx={inAppPrimaryActionSx}
        >
          Browse
        </AppButton>
        <input
          ref={inputRef}
          id={id}
          type="file"
          accept={accept}
          disabled={disabled}
          onChange={handleChange}
          style={{ display: "none" }}
        />
      </Box>
    </Box>
  );
};

export default CsvUploadField;
